var ErrorTypes = /* @__PURE__ */ ((ErrorTypes2) => {
  ErrorTypes2["BOOKING_NOT_INSTALL"] = "BOOKING_NOT_INSTALL";
  ErrorTypes2["NO_AVAILABILITY_DATES_FOUND"] = "NO_AVAILABILITY_DATES_FOUND";
  ErrorTypes2["GENERAL"] = "GENERAL";
  return ErrorTypes2;
})(ErrorTypes || {});
var DataStatus = /* @__PURE__ */ ((DataStatus2) => {
  DataStatus2["LOADING"] = "LOADING";
  DataStatus2["DONE"] = "DONE";
  DataStatus2["ERROR"] = "ERROR";
  return DataStatus2;
})(DataStatus || {});
const bulkSlotsSize = 4;
export {
  DataStatus,
  ErrorTypes,
  bulkSlotsSize
};
//# sourceMappingURL=appointment-state.js.map
